import { render, staticRenderFns } from "./report-status-admin.vue?vue&type=template&id=1cc3d048&scoped=true"
import script from "./report-status-admin.vue?vue&type=script&lang=js"
export * from "./report-status-admin.vue?vue&type=script&lang=js"
import style0 from "./report-status-admin.vue?vue&type=style&index=0&id=1cc3d048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc3d048",
  null
  
)

export default component.exports